import WellBeingPartnerTable from './WellBeingPartnerTable'

export default WellBeingPartnerTable
